import { EMessageType } from "../utils/appEnums";

export default class Result {
  constructor() {
    this.ok = true;
    this.message = "";
    this.messageType = EMessageType.Success;
    this.data = null;
    this.statusCode = "";
    this.meta = null;
    this.errorDetails = null;
  }

  setData(response) {
    this.data = response?.data;
    return this;
  }

  success(response) {
    this.message = response?.data?.message || "Success";
    this.data = response?.data?.data || response?.data;
    this.statusCode = response?.data?.statusCode;
    this.meta = response?.data?.meta;
    return this;
  }

  info(info) {
    this.message = info?.data?.message || "Info";
    this.statusCode = info?.data?.status;
    this.messageType = EMessageType.Info;
    this.ok = false;
    return this;
  }

  warning(message) {
    this.ok = false;
    this.message = message || "Warning";
    this.messageType = EMessageType.Warning;
    return this;
  }

  error(error) {
    this.ok = false;

    this.message =
      error?.data?.message ||
      error?.message ||
      "Something went wrong";

    this.errorDetails = error;
    this.messageType = EMessageType.Error;

    return this;
  }
}